<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-card-title>
            Paket Aktif
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Nama Paket</th>
                  <th>Sisa Sesi</th>
                  <th>Total Sesi</th>
                  <th>Personal Trainer</th>
                  <th>Fitness Consultant</th>
                  <th>Tanggal Mulai</th>
                  <th>Tanggal Expired</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in packages" :key="index">
                  <td>{{ item.package.name }}</td>
                  <td>{{ item.remaining_session }}</td>
                  <td>{{ item.total_session }}</td>
                  <td>{{ item.personal_trainer?.name }}</td>
                  <td>{{ item.fitness_consultant?.name || item.fitness_consultant_name || '-' }}</td>
                  <td>{{ formatDate(item.start_date) }}</td>
                  <td>{{ formatDate(item.expired_date) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from "@/core/services/api.service";
import moment from "moment";

export default {
  data() {
    return {
      packages: [],
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    await this.fetchPackages();
  },
  methods: {
    async fetchPackages() {
        const response = await ApiService.get(
          `sales/list-item-active?member_id=${this.id}`
        );
        this.packages = response.data;
       
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(price);
    },
    formatDate(date) {
      return moment(date).format("dddd, DD MMMM YYYY");
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: bold;
}
</style>
